// https://docs.microsoft.com/en-us/advertising/bulk-service/shared-negative-keyword?view=bingads-13
// Type,Status,Id,Parent Id,Campaign,Ad Group,Client Id,Modified Time,Keyword,Match Type,Name
// Format Version,,,,,,,,,,6.0
// Shared Negative Keyword,Active,,-19,,,ClientIdGoesHere,,shoes,Exact,

export const NegativeKeyword = {
  parent: 'Account',
  properties: {
    'bulk-upload-type': {
      type: 'string',
      value: 'Shared Negative Keyword',
    },
    Status: {
      'bulk-upload-header': 'Status',
    },
    Id: {
      'bulk-upload-header': 'Id',
    },
    ParentId: {
      'bulk-upload-header': 'Parent Id',
    },
    Campaign: {
      'bulk-upload-header': 'Campaign',
    },
    AdGroup: {
      'bulk-upload-header': 'Ad Group',
    },
    ClientId: {
      'bulk-upload-header': 'Client Id',
    },
    ModifiedTime: {
      'bulk-upload-header': 'Modified Time',
    },
    Keyword: {
      'bulk-upload-header': 'Keyword',
    },
    MatchType: {
      'bulk-upload-header': 'Match Type',
    },
    Name: {
      'bulk-upload-header': 'Name',
    },
  },
};
